export default __webpack_public_path__ + "img/b2d62d7503141ebab6e230c5a5c68a51.png";